import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'


const visionData = [
  {
    photo: "/integrity.jpg",
    name: "Integrity",
    desc: "We do what’s right — always. Trust and transparency guide every step we take. We believe in honesty and accountability, ensuring our clients feel secure in every interaction.",
  },
  {
    photo: "/excellence.jpg",
    name: "Excellence",
    desc: "We aim higher — delivering top-tier quality and professionalism in every service. We strive for perfection, ensuring that every detail meets our high standards.",
  },
  {
    photo: "/innovation.jpg",
    name: "Innovation",
    desc: "We embrace change — constantly evolving to bring you the latest and greatest in home solutions. arqelio leverage cutting-edge technology and creative thinking to provide unique solutions that set us apart.",
  },
  {
    photo: "/reliability.jpg",
    name: "Reliability",
    desc: "We’re here when you need us — dependable service that you can count on, every time. Prioritizing your needs, ensuring that our services are always available and consistent.",
  },
  {
    photo: "/collaboration.jpg",
    name: "Collaboration",
    desc: "We work together — building strong partnerships with our clients for the best results. We believe in the power of teamwork, ensuring that your vision is at the heart of everything we do.",
  },
  {
    photo: "/versatility.jpg",
    name: "Versatility",
    desc: "We adapt to your needs — offering a wide range of services tailored to your unique requirements. Understanding that every client is different is our strength, and we pride ourselves on our ability to customize our services to fit your specific needs.",
  }
]

const Vision = () => {
  return (
    <div className='bg-gray-400 text-gray-900 py-10'>
      {/* Vision title and button */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='max-w-7xl mx-auto text-center px-6 py-12'
      >
        <h2 className='text-4xl font-bold mb-4 text-[#29313F]'>
          Our Vision
        </h2>
        <p className='text-lg text-gray-600 mb-8'>
          We envision a world where infrastructure goes beyond function — telling stories of resilience, innovation, and purposeful design. At Arqelio, we blend modern technology with enduring expertise to build spaces, systems, and solutions that inspire progress and stand the test of time.
        </p>
        <Link to="/services">
          <button
            className='bg-[#29313F] text-white py-3 px-6 rounded-xl shadow-lg hover:bg-slate-500 transition-all duration-300'
          >
            What We Do
          </button>
        </Link>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-12'
      >
        {visionData.map((item, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: index * 0.3 }}
              className='bg-white rounded-lg shadow-xl overflow-hidden group transform transition-all hover:scale-105'
            >
              <img
                src={item.photo}
                alt={item.name}
                className="w-full h-48 object-cover"
              />

              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-4 text-[#29313F]">
                  {item.name}
                </h3>
                <p className="text-gray-600 group-hover:text-[#29313F] transition-colors duration-300">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          )
        })}

      </motion.section>
    </div>
  )
}

export default Vision